<template>
    <div class="footer-beian">
            <a href="http://beian.miit.gov.cn" target="_blank">
                <img src="@/../static/icon_gongxin.png"/>
                <span class="lh s-bottom-recordcode">{{beianGongxin}}</span>
            </a>

            <a href="http://www.beian.gov.cn/" target="_blank">
                <img src="@/../static/icon_gongan.png"/>
                <span class="lh s-bottom-recordcode">{{beianGongan}}</span>
            </a>
        </div>
</template>
<script>
export default {
    props:{
        beianGongxin:{
            type:String,
            default:''
        },
        beianGongan:{
            type:String,
            default:''
        }
    }
}
</script>

<style scoped>
.footer-beian{
    text-align: center;
    color: black;
    font-size: 16px;
    padding-top: 24px;
    padding-bottom: 24px;
}
.footer-beian a{
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/Beian.vue